import * as React from 'react';
import { Component } from 'react';
import intl from 'react-intl-universal';
import { Checkbox, Button, Modal, Row, Col } from 'antd';
import _omit from 'lodash/omit';
import './index.scss';

export default class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      enable: true,
      subEnable: false,
      rms: true,
      signature: true,
    };
  }

  componentDidMount() {
    const setting = JSON.parse(localStorage.getItem('TRUST_MANAGE_SET'));
    setting &&
      this.setState({
        ...setting,
      });
  }

  openDialog = () => {
    this.setState({
      visible: true,
    });
  };

  checkChange = (k, v) => {
    this.setState(
      {
        [k]: v,
      },
      () => {
        const setting = _omit(this.state, ['visible']);
        window.pdfui.eventEmitter.emit('setTrustManageEvt', setting);
      },
    );
  };

  handleClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const Title = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.Title' });
    const Des = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.Describe' });
    const Enable = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.Enable' });
    const Disable = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.DisablePart' });
    const Btn = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.AdvanceSetting.Btn' });
    const DTitle = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.AdvanceSetting.Title' });
    const DInfo = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.AdvanceSetting.Info' });
    const DRms = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.AdvanceSetting.Rms' });
    const DSignature = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Manage.AdvanceSetting.Signature' });
    const DOk = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Ok' });
    const DCancel = intl.formatMessage({ id: 'Preferences.Content.TrustManager.Cancel' });

    return (
      <>
        <div className="title">{Title}</div>
        <div className="LayoutGrid board tr-btn">
          <p>{Des}</p>
          <Row>
            <Col span={24}>
              <Checkbox checked={this.state.enable} onChange={(e) => this.checkChange('enable', e.target.checked)}>
                {Enable}
              </Checkbox>
            </Col>
          </Row>
          <Row style={{ display: 'none' }}>
            <Col span={20} offset={2}>
              <Checkbox checked={this.state.subEnable} disabled={!this.state.enable} onChange={(e) => this.checkChange('subEnable', e.target.checked)}>
                {Disable}
              </Checkbox>
            </Col>
          </Row>
          <Button style={{ display: 'none' }} size="small" className="mt" onClick={this.openDialog} disabled={!this.state.enable}>
            {Btn}
          </Button>
        </div>
        <Modal
          className="manage-dialog"
          maskClosable={false}
          title={DTitle}
          visible={this.state.visible}
          cancelText={DCancel}
          okText={DOk}
          onOk={this.handleClose}
          onCancel={this.handleClose}
          centered={true}>
          <div className="dialog-box">
            <p>{DInfo}</p>
            <div className="dialog-content-box">
              <Row>
                <Col span={24}>
                  <Checkbox checked={this.state.rms} onChange={(e) => this.checkChange('rms', e.target.checked)}>
                    {DRms}
                  </Checkbox>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Checkbox checked={this.state.signature} onChange={(e) => this.checkChange('signature', e.target.checked)}>
                    {DSignature}
                  </Checkbox>
                </Col>
              </Row>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
